import { configureStore } from "@reduxjs/toolkit";
import { enableMapSet } from 'immer';
import counterReducer from "./slices/counterSlice";
import userReducer from "./slices/userSlice";
import authReducer from './slices/loginRegisterSlice'
import addressValidationReducer from './slices/validateSolSlice'
import dexScreenerValidationReducer from './slices/validateDexScreenerSlice'
import botReducer from './slices/createBotSlice'
import fetchBotReducer from "./slices/fetchBotsSlice";
import startStopReducer from "./slices/StartStopSlice";
import updateGasFeeReducer from './slices/gasSlice'
import balanceReducer from './slices/balanceSlice'
import botStatusReducer from './slices/fetchBotStatus'
import tokenVolumeReducer from './slices/tokenVolumeSlice'
import walletRechargeReducer from './slices/walletRechargeSlice'
import botErrorsReducer from './slices/botErrorsSlice'
import botTradesReducer from './slices/botTradesSlice'
import socketTradesReducer from './slices/socketTradesSlice'
import passwordResetReducer from "./slices/passwordResetSlice";
import otpReducer from "./slices/otpSlice";
import sidebarReducer from "./slices/sidebarSlice";
import tokenStrengthReducer from "./slices/tokenStrengthSlice";
import tokenCreatorFormReducer from "./slices/tokenCreatorFormSlice";
import burnPagePrefillReducer from "./slices/burnPagePrefillSlice";
import liquidityPoolCreationReducer from "./slices/liquidityPoolCreationSlice";

// Enable Map and Set support in Immer
enableMapSet();

const isDev = process.env.NODE_ENV !== 'production';

// Session clearing on 401 lives only in utils/apiService (refresh cookie flow).
// Do not clearAuthData from Redux — string-matching "401" logged users out after a single
// failed dashboard call even when the access JWT was still valid.

export const store = configureStore({
    reducer: {
        counter: counterReducer,
        users: userReducer,
        auth: authReducer,
        addressValidation: addressValidationReducer,
        dexScreenerValidation: dexScreenerValidationReducer,
        createBot: botReducer,
        fetchBots: fetchBotReducer,
        startStopBots: startStopReducer,
        updateGas: updateGasFeeReducer,
        balance: balanceReducer,
        botStatus: botStatusReducer,
        tokenVolume: tokenVolumeReducer,
        walletRecharge: walletRechargeReducer,
        botErrors: botErrorsReducer,
        botTrades: botTradesReducer,
        socketTrades: socketTradesReducer,
        passwordReset: passwordResetReducer,
        otp: otpReducer,
        sidebar: sidebarReducer,
        tokenStrength: tokenStrengthReducer,
        tokenCreatorForm: tokenCreatorFormReducer,
        burnPagePrefill: burnPagePrefillReducer,
        liquidityPoolCreation: liquidityPoolCreationReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            immutableCheck: isDev ? { warnAfter: 200 } : false,
            serializableCheck: isDev ? {
                warnAfter: 200,
                // Socket trade updates can be large/high-frequency; skip deep checks for them
                ignoredActions: [
                    'socketTrades/updateBotTrades',
                    'socketTrades/updateNextTradeInfo',
                    'socketTrades/updateBotStatus',
                    'socketTrades/setBotTradesLoading',
                    'socketTrades/setBotTradesError',
                    'socketTrades/clearBotTrades',
                    'socketTrades/subscribeToBotTrades',
                    'socketTrades/subscribeToMultipleBotTrades',
                    'socketTrades/unsubscribeFromBotTrades',
                    'socketTrades/unsubscribeFromAllBotTrades'
                ],
                // Also skip scanning large nested paths
                ignoredPaths: ['socketTrades.botTrades']
            } : false
        })
})

export default store;
